var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isIonIcon)?_c('ion-icon',_vm._g(_vm._b({attrs:{"name":_vm.name}},'ion-icon',_vm.$attrs,false),_vm.$listeners)):(_vm.icon)?_c('ion-icon',_vm._g(_vm._b({attrs:{"src":_vm.url}},'ion-icon',_vm.$attrs,false),_vm.$listeners)):_c('img',_vm._g(_vm._b({attrs:{"src":_vm.url}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }